/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_SpeakersInputs */



/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Compare_Event_Groups_Option_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_speakers = /** @type {((inputs?: Compare_Event_Groups_Option_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intervenants")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecher")
	if (locale === "it") return /** @type {LocalizedString} */ ("Relatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Докладчики")
	if (locale === "es") return /** @type {LocalizedString} */ ("Oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("演讲者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("講演者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palestrantes")
	return /** @type {LocalizedString} */ ("Speakers")
});